import { mapActions, mapGetters } from 'vuex';

import MainSelect from '@/components/@core/MainSelect/index.vue';
import { PRODUCTS_ORDER_KEY } from '@/helpers';
import { MEDIA } from '@/helpers/variables';

export default {
  name: 'ProductsSelectSort',
  components: {
    MainSelect
  },
  props: {
    sortTypeDefault: {
      type: [String, null],
      default: null
    }
  },
  emits: ['change-view'],
  data() {
    return {
      MEDIA,
      sortType: PRODUCTS_ORDER_KEY.BESTSELLERS,
      list: [],
      defaultSortKey: null,
      currentSort: null
    };
  },
  created() {
    let { orderby } = this.$route.query;
    this.sortType = orderby || this.sortTypeDefault || PRODUCTS_ORDER_KEY.BESTSELLERS;
    this.defaultSortKey = this.sortTypeDefault || PRODUCTS_ORDER_KEY.BESTSELLERS;
  },
  mounted() {},
  watch: {
    translations: {
      immediate: true,
      handler(newVal) {
        setTimeout(() => {
          this._updateList();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      appSize: 'app/size',
      translations: 'setting/translations'
    })
  },
  methods: {
    ...mapActions({}),
    _updateList() {
      this.list = [
        {
          id: 0,
          key: PRODUCTS_ORDER_KEY.PRICE_DESC,
          name: this.$t('label.sortTypes.priceDesc')
        },
        {
          id: 1,
          key: PRODUCTS_ORDER_KEY.PRICE_ASC,
          name: this.$t('label.sortTypes.priceAsc')
        },
        {
          id: 2,
          key: PRODUCTS_ORDER_KEY.WITH_PROMOTIONS,
          name: this.$t('label.sortTypes.withPromotions')
        },
        {
          id: 3,
          key: PRODUCTS_ORDER_KEY.BESTSELLERS,
          name: this.$t('label.sortTypes.bestsellers')
        },
        {
          id: 4,
          key: PRODUCTS_ORDER_KEY.NEWEST,
          name: this.$t('label.sortTypes.newest')
        }
      ];
      this.currentSort = this.list.find(({ key }) => key === this.sortType);
    },
    onChangeSort(sort) {
      this.currentSort = sort;
      let { name, query, params } = this.$route;
      let editedQuery = { ...query };

      if (sort.key === this.defaultSortKey) {
        delete editedQuery.orderby;
      } else {
        editedQuery = { ...editedQuery, orderby: sort.key };
      }
      this.$router.push({ name, query: editedQuery, params }).catch(() => {});
    }
  }
};
